export class PrettyJSON
{
  static stringify( data:any )
  {
    return JSON.stringify( data, null, "  " );
  }


  static xhr<T>( url:string, data:any ):Promise<T> 
  { 
    console.log( "sending", url );

    let promise = new Promise<T>(
      ( resolve, reject )=>
      {
        let xhr = new XMLHttpRequest();
        xhr.open( "POST", url, true );
        xhr.setRequestHeader( "Content-Type", "application/json");

        let sendingData = typeof data === "string" ? data : JSON.stringify( data );

        xhr.onerror = ( e )=>  
        {
          console.log( "ERROR:", url );
          console.log( e );
          
          reject();
        }

        xhr.onload = ()=>
        {
          try
          {
            let responseText = xhr.responseText;

            console.log( `RESPONSED: '${responseText}'` );

            if ( /^(\s|\n|\r)+{/.test( responseText ) ) 
            {
              let jsonObject = JSON.parse( responseText );

              resolve( jsonObject as T );
            }
            else
            {
              
              reject();
            }
            
          }
          catch( e )
          {
            reject();
          }
          
        }

        console.log( "Sending", sendingData, "to", url );
        xhr.send( sendingData );

      }
    )

    return promise;

  }
}